class BaseComponentController{

    constructor(_, componentRegistryService, $q) {
        this.model = null;
        this._ = _;
        this.componentRegistryService = componentRegistryService;
        this.q = $q;
    }

    getModel() {
        if (!this._.isEmpty(this.model) || (this.model === true || this.model === false)) {
            return this._.fromPairs([[this.modelName, this.model]]);
        }

        return null;
    }

    setModel(model) {              
        this.model = model;   
    }

    _register() {
        this.componentRegistryService.register(this);
    }
    
    $onInit() {
        this._register();
        this.init();
    }

    $onDestroy() {
        this.componentRegistryService.deregister(this);
    }

    validate() {
        return true;
    }

    getPromise(value) {
        let deferred = this.q.defer();
        deferred.resolve(value);
        return deferred.promise; 
    }
}

export default BaseComponentController;
   


// WEBPACK FOOTER //
// ./app/components/base-component.controller.js